module.exports = __webpack_public_path__ + "img/gartek-services-mechanical-since-1980.4930a123.png";